import * as types from './mutation-types.js'
export default {

   [types.NUM](state,count){
       state.num=count
  },
  [types.ADDCOUNTID](state,count){
    //   let goods=state.goodsCarList.find(item=>item.goods_id===count.goods_id)
    //   if(goods){
    //   count.car_num++;
    // }else {
    //     count.car_num=1;
    //    state.goodsCarList.push(count);
    // }
  },
  [types.REDUCECOUNTID](state,goods){
     // state.goodsCarList.splice(state.goodsCarList.indexOf(goods),1)
  },
  //  [types.ADDPRODUCECAR](state,produce){
  //    let goods=state.goodsCarList.find(item=>item.goods_id===goods.goods_id)
  //    if(goods){
  //      state.goodsCarList.map(item=>item.count=goods.count)
  //      state.goodsCarList=[...state.goodsCarList]
  //    }else {
  //      state.goodsCarList=[...state.goodsCarList,goods]
  //    }
  // },

  [types.CHECKGOODS](state,produce){
     state.produces=produce
  },
  [types.CHECKRETURNGOODS](state,Reproduce){
     state.Reproduces=Reproduce
  },
  // [types.CURUSER](state,user){
  //    state.curuser=user
  // },
//   [types.GOPAY](state,pay){
//      state.pay=pay
//   },
  [types.USERINFO](state,userinfo){
     state.UserInfo=userinfo
  },
  [types.TYPEID](state,typeid){
     state.typeId=typeid
  },
  [types.TYPENAME](state,typename){
     state.typeName=typename
  },
   [types.TYPEGRADE](state,typegrade){
     state.typeGrade=typegrade
  },
   [types.ADDNAV](state,navproduce){
     state.navdata=navproduce
  },

  [types.GOEDIT](state,f){
     state.editData=f
  },
  // [types.GOODS](state,cargoods){
  //    state.goods=cargoods
  //
  // },
  [types.GOPAY1](state,producepay){
     state.produces=producepay
  },
  [types.PRODUCELIST](state,listsgoods){
     state.producelist=listsgoods
  },
  [types.ORDERPAY](state,order){
     state.pay=order
  },
  [types.CLIENTID](state,id){
     state.clientid=id
  },

   [types.GOCLIENTID](state,id){
     state.goClientId=id
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js